// DS: C35
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import UserAvatar from '../../User/Avatar';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { getDeviationTitle } from '../../DeviationViews/_helpers';
import Author from '../_partials/Author';
import GroupDetail from '../_partials/GroupDetail';
import Title from '../_partials/Title';
import PublishedTime from '../_partials/PublishedTime';
import s from './DesktopSubmissionDetails.scss';
var DesktopSubmissionDetails = function (_a) {
    var _b, _c;
    var className = _a.className, deviation = _a.deviation, _d = _a.deviation, author = _d.author, extended = _d.extended, isOwner = _a.isOwner, showTitle = _a.showTitle;
    var t = useTranslation().t;
    var deviationTitle = getDeviationTitle(deviation);
    var isShowingTitle = deviationTitle && showTitle;
    var _e = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), isPremium = _e.isPremium, isPaidFolder = _e.isPaidFolder;
    var premiumTooltip = isPaidFolder
        ? t('deviation.details.premiumFolder.tooltip')
        : t('deviation.details.watchersOnlyFolder.tooltip');
    var PremiumIcon = isPaidFolder ? Premium : EyeDisc2;
    return (React.createElement("div", { className: classnames(s['root'], !isShowingTitle && s['no-title'], className) },
        React.createElement(BiLoggerContextProvider, { value: { sectionname: 'author' } },
            React.createElement("div", { className: s['left'] }, author && (React.createElement(UserAvatar, { withTooltip: true, relatedItemBiData: {
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId,
                }, size: 50, user: (_b = extended === null || extended === void 0 ? void 0 : extended.exclusiveGroup) !== null && _b !== void 0 ? _b : author, className: s['avatar'] }))),
            React.createElement("div", { className: s['middle'] },
                isShowingTitle && (React.createElement("div", { className: s['title-row'] },
                    isPremium && (React.createElement(SimpleTooltip, { className: s['premium-icon'], text: premiumTooltip },
                        React.createElement(PremiumIcon, { size: IconSize.SMALL }))),
                    React.createElement(Title, { title: deviationTitle, showTitle: true, className: s['title'] }),
                    React.createElement(PublishedTime, { className: s['published-time'], publishedTime: deviation.publishedTime }))),
                React.createElement("div", { className: s['middle-lower'] },
                    (extended === null || extended === void 0 ? void 0 : extended.exclusiveGroup) && (React.createElement(GroupDetail, { group: extended.exclusiveGroup, className: s['group'] })),
                    React.createElement(Author, { author: (_c = extended === null || extended === void 0 ? void 0 : extended.originalAuthor) !== null && _c !== void 0 ? _c : author, isOwner: isOwner, className: s['original-author'] }))),
            !isShowingTitle && (React.createElement("div", { className: s['right'] },
                React.createElement(PublishedTime, { className: s['published-time'], publishedTime: deviation.publishedTime }))))));
};
DesktopSubmissionDetails.displayName = 'DesktopSubmissionDetails';
export default DesktopSubmissionDetails;
//# sourceMappingURL=DesktopSubmissionDetails.js.map